const isDev = import.meta.env.DEV && location.hostname === 'localhost';

export async function listLocalSecrets() {
  if (!isDev) return { ok:false, secrets:{} };
  const r = await fetch('/__local/secrets');
  return r.json();
}

export async function saveLocalSecret(name, value) {
  if (!isDev) return { ok:false, error:'not-dev' };
  const r = await fetch('/__local/secrets', {
    method:'POST',
    headers:{ 'Content-Type':'application/json' },
    body: JSON.stringify({ name, value })
  });
  return r.json();
}

export const localSecretsMode = isDev;

